import { useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial } from "../../Common/Utils/ThreeTools"

export default function Coaster(props: ProductModelProps) {
    const url = new URL('@resources/3d-models/glb/coaster.glb', import.meta.url);
    const model = useGLB(url)
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    // Apply lab texture
    useEffect(() => {
        if (!elements) return

        let mat = FindMaterial('coaster', elements)
        if (!mat) return
        mat.map = productTexture
        mat.map.flipY = false
        mat.map.needsUpdate = true
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}